import React from 'react';
import PropTypes from 'prop-types';
// Local Deps
import './InventoryManagementMenu.scss';
import msgs from '../../config/messages';
import NFButton from '../primitives/NFButton';
import InventoryManagementCaps from '../../config/searchFilters/InventoryManagementFilters';
import Loading from '../Loading';

// Components
import FilterGroup from '../FilterGroup';

export default class InventoryManagementMenu extends React.PureComponent {
  static propTypes = {
    selectedMenu: PropTypes.object,
    onMenuClick: PropTypes.func,
    onInventoryFilter: PropTypes.func.isRequired,
    isDownloading: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    selectedMenu: { value: 'inventoryGrid' },
    onMenuClick: () => { },
  };

  _clearPartNumDes = () => {
    document.getElementById('partNum').value = '';
    document.getElementById('description').value = '';
  };
  _clearNiinDesc = () => {
    document.getElementById('niin').value = '';
    document.getElementById('description').value = '';
  };
  _clearNiinPartNum = () => {
    document.getElementById('niin').value = '';
    document.getElementById('partNum').value = '';
  };

  _clearFilters = () => {
    window.location.reload();
  };

  render() {
    const { selectedMenu, onMenuClick, onInventoryFilter, isDownloading } = this.props;
    return (
      <div className="nf-solicitations-menu">
        <FilterGroup
          {...InventoryManagementCaps}
          onFilterClick={onMenuClick}
          selectedFilter={[selectedMenu.value]}
        />
        {isDownloading && (
          <Loading
            text="Downloading File"
          />
        )}
        {selectedMenu.value === 'inventoryGrid' && (
          <div className="nf-tool-filter-group">
            <h6 className="nf-tool-filter-group-header">Search Inventory Management Records</h6>
            {/*
            <div className="nf-tool-filter-item">NSN/NIIN:</div>
            <input
              name="niin"
              id="niin"
              type="text"
              className="ant-input"
              onClick={this._clearPartNumDes}
            />
*/}


            <span className="ant-input-wrapper ant-input-group" style={{ 'margin-bottom': 6 }}>
              <span className="ant-input-group-addon">NSN/NIIN</span>
              <input
                name="niin"
                id="niin"
                type="text"
                className="ant-input"
                onClick={this._clearPartNumDes}
              />
            </span>



            {/*
            <div className="nf-tool-filter-item">Part Number:</div>
            <input
              name="partNum"
              id="partNum"
              type="text"
              className="ant-input"
              onClick={this._clearNiinDesc}
            />
        */}

            <span className="ant-input-wrapper ant-input-group" style={{ 'margin-bottom': 6 }}>
              <span className="ant-input-group-addon">Part Number</span>
              <input
                name="partNum"
                id="partNum"
                type="text"
                className="ant-input"
                onClick={this._clearNiinDesc}
              />
            </span>

            {/*
            <div className="nf-tool-filter-item">Description:</div>
            <input
              name="description"
              id="description"
              type="text"
              className="ant-input"
              onClick={this._clearNiinPartNum}
            />
*/}

            <span className="ant-input-wrapper ant-input-group" style={{ 'margin-bottom': 6 }}>
              <span className="ant-input-group-addon">Description</span>
              <input
                name="description"
                id="description"
                type="text"
                className="ant-input"
                onClick={this._clearNiinPartNum}
              />
            </span>


            <div className="nf-tool-filter-buttons">
              <NFButton
                className="nf-button--gray-border"
                onClick={this._clearFilters}
              >
                Reset
              </NFButton>
              <NFButton
                className="nf-button--form nf-tooling-button nf-button--orange"
                onClick={onInventoryFilter}
              >
                {msgs.Form.submitButton}
              </NFButton>
            </div>


          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/InventoryManagementMenu/InventoryManagementMenu.jsx